import _Object$create from "@babel/runtime-corejs3/core-js-stable/object/create";
import { useMemo, useRef } from 'react';
export default function useRefFrom(value) {
  var ref = useRef();
  var readOnlyRef = useMemo(function () {
    return _Object$create({}, {
      current: {
        get: function get() {
          return ref.current;
        }
      }
    });
  }, [ref]);
  ref.current = value;
  return readOnlyRef;
}
//# sourceMappingURL=useRefFrom.js.map